import React, { Component, } from 'react'

class fixErrorsLink extends Component {
    constructor(props){
        super(props)
        this.handleClick = this.handleClick.bind(this)
    }
handleClick(){
    let currentURL = window.location.href
    if(currentURL.includes("#main-content")){
        let originalURL = currentURL.replace("#main-content", "")
        let newURL = originalURL + "fixErrors"
        window.location.assign(newURL)
    }else{
        let newURL = currentURL + "fixErrors"
        window.location.assign(newURL)
    }


}

    render() {
        return (
            <li className="btn btn-sm btn-secondary borderfix"><strong><button type="button" className="linkButton" onClick={this.handleClick} tabIndex="0">Fix Errors and Warnings</button></strong>
            </li>
        )
    }
}
export default fixErrorsLink